import * as React from "react";
import type { SVGProps } from "react";
const SvgType = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M3 7a1 1 0 0 0 2 0zm1-3V3a1 1 0 0 0-1 1zm16 0h1a1 1 0 0 0-1-1zm-1 3a1 1 0 1 0 2 0zM9 19a1 1 0 1 0 0 2zm6 2a1 1 0 1 0 0-2zM13 4a1 1 0 1 0-2 0zm-2 16a1 1 0 1 0 2 0zM5 7V4H3v3zM4 5h16V3H4zm15-1v3h2V4zM9 21h6v-2H9zm2-17v16h2V4z"
    />
  </svg>
);
export default SvgType;
